<div class="row">
    <div
    class="col-md-6"
    *ngFor="
      let dynamicOption 
      of pUiService.productView.ProductOptionItems[pUiService.currentOptionIndex]
        .DynamicProductOptions; let dynamicOptionIndex = index
    "
  >
    <div class="form-group col-md-12">
      <label for="number-of-fixes" class="title-label">
        {{ dynamicOption.OptionTitle }} {{clientTransactionViewForm.get(['DynamicOptionResponses', dynamicOptionIndex])?.value?.DynamicOptionItemId}} 
      </label>
      <select
        [ngClass]="{ changedField: pUiService.markedFields[3] }"
        class="form-control dynamic-option-select"
        #dynamicOptionSelect
        (change)="onDynamicOptionChange(dynamicOptionIndex, $event)"
        [value]="clientTransactionViewForm.get(['DynamicOptionResponses', dynamicOptionIndex])?.value?.DynamicOptionItemId"
      >
        <option
          *ngFor="
            let dynamicOptionItem of dynamicOption.DynamicProductOptionItems;
          "
          [value]="dynamicOptionItem.Id"
        >
          {{ dynamicOptionItem.Label }}
        </option>
      </select>
      <span
      *ngIf="getSelectedDynamicFieldPrice(dynamicOptionIndex)>0"
        class="dynamic-option-price add-money-field"
        >+ {{ getSelectedDynamicFieldPrice(dynamicOptionIndex) | number: pUiService.DECIMAL_RULE}} ₪</span
      >
    </div>
  </div>
</div>
